<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoDespublicar" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-list-tile-title slot="activator">
                <v-icon class="material-icons mr-2" small>
                    unpublished
                </v-icon>
                Despublicar
            </v-list-tile-title>

            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    Despublicar Compra
                </v-card-title>
                <v-card-text class="pb-0 az-form-content">
                    <div class="az-text mb-3">
                        <p><strong>Informe o motivo para despublicar a Compra Direta</strong></p>
                    </div>

                    <v-textarea v-model="motivo"
                                :error-messages="errors.collect('Motivo')"
                                v-validate="mostrarDialogoDespublicar? 'required' : ''"
                                :name="'Motivo'"
                                label="Motivo"
                                placeholder="Digite aqui o motivo"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"
                                class="required-field"/>
                </v-card-text>
                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="mostrarDialogoDespublicar = false">
                        Fechar
                    </v-btn>
                    <v-spacer/>
                    <v-btn color="primary" depressed @click="confirmarDespublicacao">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'AcoesDespublicar',
    props: ['compraDiretaId'],
    data() {
        return {
            motivo: null,
            mostrarDialogoDespublicar: false,
            Modal
        }
    },
    methods:{
        async confirmarDespublicacao(){
            await this.validarCampos()
            this.mostrarDialogoDespublicar = false
            this.$emit('confirmarDespublicacao', {compraDiretaId: this.compraDiretaId, motivo: this.motivo})
        },
        async validarCampos(){
            const estaValidado = await this.$validator.validateAll()
            if(!estaValidado){
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important

    .acoes
        padding 20px 0 !important

    .painel-item
        box-shadow none
        border-top 1px solid rgba(0, 0, 0, .12)

    .painel-titulo
        color #777
        text-align right
</style>
